import { navbarHeight } from '@Containers/Layout/Navbar';
import { useGetProgress } from '@Domains/Progress';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useProfile } from 'src/Constant/UserProfileContext/UserProfileProvider';
import SidebarMenu from './SidebarMenu';

export const SIDEBAR_WIDTH = 289;

const SidebarContainer = () => {
  const { breadcrumbs } = useProgressBar();

  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useProfile();
  const companyId = user?.I_COMPANY_ID?.toString() || '';
  const [{ loading }, refetch] = useGetProgress(Number(id), companyId);

  const handleNavigate = async () => {
    try {
      await refetch();
      navigate(`/?report=${breadcrumbs?.reportId}`);
    } catch (error) {
      console.error('Error fetching progress:', error);
      navigate('/');
    }
  };

  return (
    <Box
      width={SIDEBAR_WIDTH}
      bgcolor="white"
      px={2}
      py={3}
      borderRight="1px solid #D9D9D9"
      minHeight={`calc(100vh - ${navbarHeight}px)`}
      border={0}
    >
      <Button
        variant="text"
        fullWidth
        sx={{
          color: 'black',
        }}
        startIcon={
          <ArrowBackIosNewOutlinedIcon
            fontSize="large"
            sx={{ color: 'black' }}
          />
        }
        onClick={handleNavigate}
        disabled={loading}
      >
        <Typography variant="h3">CVUP Report</Typography>
      </Button>
      <Divider sx={{ my: 2 }} />
      <SidebarMenu />
    </Box>
  );
};

export default SidebarContainer;
